import { useRouter } from 'next/router';
import { IoEarthOutline } from 'react-icons/io5';
import { ExtendedDbCloudWalletUserInfo } from '@shared/types/db/user';
import { GeniusUserPane } from '@/components/asset/sendFunds/userSearchResults';
import ImageWithFallback from '@/components/shared/ImageWithFallback';
import { useSession } from '@/contexts/LitSessionProvider';
import { useGetUsernames } from '@/hooks/auth/useGetUsernames';
import { getNetworkLogo } from '@/lib/misc/tokenImageHelper';
import { shortAddr, toSpecialFixed } from '@/lib/misc/utils';
import TokenImage from '@/components/shared/TokenImage';
import { useIsMobile } from '@/hooks/utilities/use-mobile';
import useAppDetails from '@/hooks/utilities/useAppDetails';
export default function TransferHeader({
  txItem
}) {
  const {
    PKP
  } = useSession();
  const router = useRouter();
  const isSend = txItem?.from_address === PKP?.additionalEthAddress || txItem?.from_address === PKP?.solanaAddress;
  const geniusAddressToCheck = isSend ? txItem?.to_address : txItem?.from_address;
  const {
    data: geniusInfo
  } = useGetUsernames({
    address: geniusAddressToCheck
  });
  const isMobile = useIsMobile();
  const {
    setMobileMode,
    setMobileModeMetadata
  } = useAppDetails();
  return <>
      <div className='my-5 text-[14px] text-genius-cream/50'>
        <p>{isSend ? 'Sent to' : 'Received from'}</p>
      </div>
      <div className={`bg-genius-blue h-[64px] flex justify-between gap-4 items-center px-4 p-3 rounded-md border border-genius-blue`}>
        {(geniusInfo as ExtendedDbCloudWalletUserInfo[])?.length ? <GeniusUserPane user={geniusInfo[0]} className='px-0' /> : <div className={`flex gap-4 items-center w-full`}>
            <ImageWithFallback src={getNetworkLogo(txItem?.chain_id)} alt='network' width={36} height={36} />
            <div className='grid justify-items-start w-full'>
              <p className='text-[12px] text-genius-cream'>{shortAddr(txItem?.to_address)}</p>
              <p className='text-[10px] w-full text-genius-cream/50 break-all'>
                {txItem?.to_address}
              </p>
            </div>
            <div className='ta-r'>
              <IoEarthOutline />
            </div>
          </div>}
      </div>

      <div className='mt-6 w-full text-genius-cream flex flex-col gap-4'>
        <div className='flex w-full justify-between'>
          <p className='text-[14px] text-genius-cream/50'>Value</p>
          <p className='text-[14px]'>${toSpecialFixed(txItem.usd_value, 2)?.value}</p>
        </div>
        <div className='flex w-full justify-between cursor-pointer' onClick={() => {
        if (isMobile) {
          setMobileMode('asset');
          setMobileModeMetadata({
            networkId: txItem.network,
            address: txItem.tokenAddress,
            prev_m_mode: 'transfer'
          });
          router.push(`/home?m_mode=asset&networkId=${txItem.network}&address=${txItem.tokenAddress}`, undefined, {
            shallow: true
          });
        } else {
          router.push(`/asset?address=${txItem.tokenAddress}&networkId=${txItem.network}`);
        }
      }}>
          <p className='text-[14px] text-genius-cream/50'>Token</p>
          <div className='flex flex-col items-end'>
            <div className='flex w-full flex-col items-end'>
              <div className='text-[14px] flex items-center'>
                <TokenImage mainImageSrc={txItem?.token_metadata?.image_small_url || getNetworkLogo(txItem?.chain_id)} badgeImageSrc={getNetworkLogo(txItem?.chain_id)} size={18} badgeSize={10} className='mr-2' data-sentry-element="TokenImage" data-sentry-source-file="TransferHeader.tsx" />
                {toSpecialFixed(txItem.token_amount_formatted, 2)?.value}{' '}
                {txItem?.token_metadata?.symbol}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>;
}